import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { fetchWithAuth } from '../utils/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
    setLoading(false);
  }, []);

  const login = (userData) => {
    setUser(userData);
    localStorage.setItem('user', JSON.stringify(userData));
  };

  const logout = useCallback(() => {
    const performLogout = () => {
      setUser(null);
      localStorage.removeItem('user');
    };

    // The session cookie is HttpOnly so we can't clear it from JS — hit
    // /logout so the backend invalidates the session and clears the cookie.
    if (user) {
      fetchWithAuth('/logout', {
        method: 'POST'
      }, user, performLogout).finally(performLogout);
    } else {
      performLogout();
    }
  }, [user]);

  const hasPermission = useCallback((section) => {
    if (!user) return false;
    if (user.role === 'admin') return true;
    if (!user.permissions) return false;
    const perms = user.permissions.split(',');
    return perms.includes(section) || perms.includes('all');
  }, [user]);

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, hasPermission }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
